import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { SidebarTabNames } from '@pages/Admin/Campaign/ui/constants';
import { SidebarTabNamesType } from '@pages/Admin/Campaign/ui/types';
import { CampaignDto } from '@shared/services/apiService/apiService';

interface UseEditCampaignTabRoutingOptions {
  campaignData?: CampaignDto;
  isSquadCampaign: boolean;
}

export const useEditCampaignTabRouting = ({
  campaignData,
  isSquadCampaign,
}: UseEditCampaignTabRoutingOptions) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const activeTab = useMemo((): SidebarTabNamesType | null => {
    const tab = searchParams.get('tab');
    if (!tab) {
      return null;
    }

    const resolvedTab = (tab === 'tools' ? SidebarTabNames.SETTINGS : tab) as SidebarTabNamesType;

    if (resolvedTab === SidebarTabNames.SQUADS && campaignData && !isSquadCampaign) {
      return SidebarTabNames.AGENT;
    }

    return resolvedTab;
  }, [searchParams, campaignData, isSquadCampaign]);

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (!tab) {
      navigate(`${window.location.pathname}?tab=${encodeURIComponent(SidebarTabNames.GENERAL)}`, {
        replace: true,
      });
      return;
    }

    const resolvedTab = tab === 'tools' ? SidebarTabNames.SETTINGS : tab;
    if (resolvedTab === SidebarTabNames.SQUADS && campaignData && !isSquadCampaign) {
      navigate(`${window.location.pathname}?tab=${encodeURIComponent(SidebarTabNames.AGENT)}`, {
        replace: true,
      });
    }
  }, [campaignData, isSquadCampaign, navigate, searchParams]);

  return activeTab;
};
